import Link from "next/link";

export function LogoMark({ className = "" }: { className?: string }) {
  // Stacked document sheets (navy) with an emerald check badge — per brand guide.
  return (
    <svg viewBox="0 0 40 40" className={className} aria-hidden="true" fill="none">
      <rect x="12" y="5" width="20" height="27" rx="3" fill="#cdd6e6" />
      <rect x="7" y="8.5" width="20" height="27" rx="3" fill="var(--color-navy)" />
      <rect x="11" y="15" width="12" height="2" rx="1" fill="#ffffff" opacity="0.92" />
      <rect x="11" y="20" width="12" height="2" rx="1" fill="#ffffff" opacity="0.55" />
      <rect x="11" y="25" width="8" height="2" rx="1" fill="#ffffff" opacity="0.55" />
      <circle cx="29.5" cy="28.5" r="8.5" fill="var(--color-emerald)" stroke="#ffffff" strokeWidth="2" />
      <path d="M26 28.5 l2.4 2.4 l4.6 -5" stroke="#ffffff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function Logo({ className = "", reversed = false }: { className?: string; reversed?: boolean }) {
  return (
    <Link href="/" className={`group inline-flex items-center gap-2.5 ${className}`} aria-label="RamsDocs home">
      <LogoMark className="h-9 w-9" />
      <span
        className="font-display text-[1.35rem] font-extrabold tracking-tight"
        style={{ color: reversed ? "#ffffff" : "var(--color-ink)" }}
      >
        RamsDocs
      </span>
    </Link>
  );
}
